(function(){
  "use strict";
  var $ = function(id){ return document.getElementById(id); };
  var todos = function(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); };
  var eur = function(v){ return v.toFixed(2).replace(".", ",") + " €"; };
  var quieto = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function anima(el, clase){ el.classList.remove(clase); void el.offsetWidth; el.classList.add(clase); }

  /* ---------- barra de avance y barra fija ---------- */
  (function(){
    var barra = $("avance");
    function pinta(){
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      var p = alto > 0 ? (window.scrollY / alto) * 100 : 0;
      barra.style.width = p + "%";
      var st = $("sticky"); if(st) st.classList.toggle("on", p > 12 && $("cart").hidden);
    }
    window.addEventListener("scroll", pinta, {passive:true});
    window.addEventListener("resize", pinta);
    pinta();
  })();

  /* ---------- entradas al hacer scroll ---------- */
  var mirar = (function(){
    if(!("IntersectionObserver" in window)){
      return function(el, hacer){ if(el) hacer(el); };
    }
    return function(el, hacer){
      if(!el) return;
      var obs = new IntersectionObserver(function(e, o){
        if(e[0].isIntersecting){ hacer(el); o.disconnect(); }
      }, {threshold:.15, rootMargin:"0px 0px -40px 0px"});
      obs.observe(el);
    };
  })();
  todos(".sube").forEach(function(el){ mirar(el, function(){ el.classList.add("ya"); }); });

  /* ---------- héroe: anotaciones y tubo que sigue al ratón ---------- */
  setTimeout(function(){ todos(".call").forEach(function(c){ c.classList.add("ya"); }); }, 350);
  (function(){
    var art = $("art"), tubo = art ? art.querySelector(".art__img") : null;
    if(!tubo || quieto) return;
    art.addEventListener("mousemove", function(e){
      var c = art.getBoundingClientRect();
      tubo.style.setProperty("--px", (((e.clientX - c.left) / c.width) - .5) * 26 + "px");
      tubo.style.setProperty("--py", (((e.clientY - c.top) / c.height) - .5) * 18 + "px");
    });
    art.addEventListener("mouseleave", function(){
      tubo.style.setProperty("--px", "0px"); tubo.style.setProperty("--py", "0px");
    });
  })();

  /* ---------- números que suben ---------- */
  todos("[data-cuenta]").forEach(function(el){
    mirar(el, function(){
      if(quieto) return;
      var bueno = el.textContent;                 // el valor final ya esta en el HTML
      var fin = parseFloat(el.dataset.cuenta.replace(",", ".")), suf = el.dataset.suf || "";
      var dec = el.dataset.cuenta.indexOf(",") > -1 ? 1 : 0, cortado = false;
      var t0 = Date.now();
      // El reloj es el del sistema, no la marca del fotograma: si el navegador tarda en pintar
      // (pestana de fondo, captura automatica, movil cargando), el primer fotograma que llega
      // ya calcula k=1 y cae en el valor final en vez de quedarse a medias.
      setTimeout(function(){ cortado = true; el.textContent = bueno; }, 1500);
      requestAnimationFrame(function paso(){
        if(cortado) return;
        var k = Math.min((Date.now() - t0) / 900, 1), v = fin * (1 - Math.pow(1 - k, 3));
        el.textContent = k < 1 ? v.toFixed(dec).replace(".", ",") + suf : bueno;
        if(k < 1) requestAnimationFrame(paso); else cortado = true;
      });
    });
  });

  /* ---------- la noche, hora a hora ---------- */
  var NOCHE = [
    {h:"23:00", g:"gSup", y:0, c:"Pantenol", cielo:"#0A0C09",
     t:"Se aplica en seco",
     p:"Una cantidad del tamaño de un guisante en la cara limpia y seca. En piel húmeda el retinal entra más rápido de la cuenta y por eso pica: sécate bien y espera un minuto."},
    {h:"00:00", g:"gCorneo", y:60, c:"Retinal 0,1 %", cielo:"#0C100B",
     t:"Atraviesa la capa córnea",
     p:"La capa de arriba son células muertas y grasa, puestas como ladrillos. El sérum es ligero para colarse entre ellos en vez de quedarse encima."},
    {h:"01:00", g:"gEpi", y:140, c:"Un solo paso", cielo:"#10150D",
     t:"Se convierte en lo que sirve",
     p:"Aquí está la gracia del retinal: le falta una sola conversión para ser ácido retinoico. El retinol necesita dos, y en cada paso pierde fuerza."},
    {h:"02:00", g:"gBasal", y:240, c:"Capa basal", cielo:"#151B0F",
     t:"Llega al núcleo de la célula",
     p:"Se une a los receptores de la célula viva y les cambia las instrucciones. A partir de aquí la piel no está reparando: está fabricando."},
    {h:"03:00", g:"gBasal", y:250, c:"Pico de renovación", cielo:"#1C2212",
     t:"La hora en que más se divide",
     p:"La división celular alcanza su máximo de madrugada. Por eso esto se usa de noche: de día estarías desaprovechando medio bote."},
    {h:"04:00", g:"gDermis", y:330, c:"Colágeno", cielo:"#2A2A18",
     t:"La orden baja a la dermis",
     p:"Los fibroblastos reciben el aviso y suben la producción de colágeno. Esto es lo lento: se mide en meses, no en noches, y por eso la pauta es de 12 semanas."},
    {h:"05:00", g:"gPoro", y:200, c:"Moistshield HA 3 %", cielo:"#4A4328",
     t:"El complejo hidratante aporta agua",
     p:"El complejo con ácido hialurónico aporta agua a la piel mientras el retinal sigue trabajando. Es lo que acompaña a la renovación para que la piel no se quede tirante."},
    {h:"07:00", g:"gSup", y:0, c:"Pantenol", cielo:"#9E9A5E",
     t:"Amanece y la barrera cierra",
     p:"El pantenol ha acompañado a la barrera de la piel durante la noche. Te lavas la cara, protección solar y a por el día."}
  ];
  (function(){
    var corte = $("corte"), rango = $("rango"), marcas = $("marcas"), reproduciendo = null;
    if(!corte) return;                       // la noche solo esta en la portada
    NOCHE.forEach(function(){ marcas.appendChild(document.createElement("span")); });
    var puntos = todos("#marcas span");

    function pinta(i){
      var p = NOCHE[i];
      corte.style.setProperty("--luzY", p.y + "px");
      $("cieloCorte").setAttribute("fill", p.cielo);
      todos("#corte .g").forEach(function(g){ g.classList.toggle("on", g.id === p.g); });
      $("hora").textContent = p.h;
      $("pasoN").textContent = "Paso " + (i + 1) + " de " + NOCHE.length;
      $("pasoT").textContent = p.t;
      $("pasoP").textContent = p.p;
      $("pasoC").textContent = p.c;
      var pct = i / (NOCHE.length - 1) * 100;
      $("hecho").style.width = pct + "%";
      $("cieloPin").style.left = pct + "%";
      puntos.forEach(function(s, n){
        s.classList.toggle("pasada", n <= i);
        s.classList.toggle("ahora", n === i);
      });
      if(!quieto) anima($("paso"), "cambia");
      if(rango.value !== String(i + 1)) rango.value = String(i + 1);
    }
    function parar(){
      if(reproduciendo){ clearInterval(reproduciendo); reproduciendo = null; }
      $("playTxt").textContent = "Reproducir la noche";
      $("playIco").setAttribute("d", "M0 0l11 6.5L0 13z");
    }
    rango.addEventListener("input", function(){ parar(); pinta(+rango.value - 1); });
    $("prev").addEventListener("click", function(){ parar(); pinta(Math.max(0, +rango.value - 2)); });
    $("next").addEventListener("click", function(){ parar(); pinta(Math.min(NOCHE.length - 1, +rango.value)); });
    $("play").addEventListener("click", function(){
      if(reproduciendo){ parar(); return; }
      var i = (+rango.value - 1 >= NOCHE.length - 1) ? 0 : +rango.value - 1;
      pinta(i);
      $("playTxt").textContent = "Parar";
      $("playIco").setAttribute("d", "M0 0h4v13H0zM7 0h4v13H7z");
      reproduciendo = setInterval(function(){
        i++;
        if(i >= NOCHE.length){ parar(); return; }
        pinta(i);
      }, 2600);
    });
    pinta(0);
  })();

  /* ---------- el escalón del retinoide ---------- */
  var RETI = [
    {n:"Retinol", pasos:"2 pasos hasta el ácido retinoico", vel:38, irr:45, rec:100,
     t:"El de toda la vida. Funciona, pero pierde fuerza en cada conversión, así que hace falta mucha concentración y mucha paciencia."},
    {n:"Retinaldehído", pasos:"1 paso hasta el ácido retinoico", vel:72, irr:55, rec:100,
     t:"Le falta una sola conversión, así que trabaja antes que el retinol sin saltar a la potencia de la receta. Es el escalón del medio, y es el que lleva este tubo."},
    {n:"Tretinoína", pasos:"0 pasos: ya es ácido retinoico", vel:100, irr:95, rec:0,
     t:"Es el ácido retinoico directamente. Va más rápido que ninguno y por eso irrita más, y por eso en España necesitas receta médica."}
  ];
  (function(){
    if(!$("rNombre")) return;               // el escalon solo esta en la portada
    function pinta(i){
      var r = RETI[i];
      $("rNombre").textContent = r.n;
      $("rPasos").textContent = r.pasos;
      $("rTexto").textContent = r.t;
      $("bVel").style.width = r.vel + "%";
      $("bIrr").style.width = r.irr + "%";
      $("bRec").style.width = r.rec + "%";
      $("pistaLleno").style.width = (i * 50) + "%";
      todos(".pista__hitos button").forEach(function(b){ b.setAttribute("aria-pressed", String(+b.dataset.r === i)); });
      todos(".pista__nombres span").forEach(function(s){
        if(+s.dataset.n === i){ s.setAttribute("data-on", "si"); } else { s.removeAttribute("data-on"); }
      });
    }
    todos(".pista__hitos button").forEach(function(b){
      b.addEventListener("click", function(){ pinta(+b.dataset.r); });
    });
    pinta(1);
  })();

  /* ---------- tu pauta ---------- */
  (function(){
    if(!$("cal")) return;                   // la pauta solo esta en la portada
    var resp = {piel:null, exp:null, meta:null}, pauta = null;
    var PACKS = {"1":{label:"1 tubo"},"2":{label:"2 tubos"},"3":{label:"3 tubos"},"5":{label:"5 tubos"}};
    var TEXTO = {
      poros:"Para poros y marcas lo que cuenta es la constancia: la renovación de la superficie suele empezar a notarse hacia la semana 6-8.",
      lineas:"Para líneas finas manda el colágeno, y el colágeno va lento: la foto buena es la de la semana 12, no la del primer mes.",
      tono:"Para el tono apagado es lo más agradecido: la renovación se ve en la cara por la mañana a partir de la cuarta semana."
    };
    function calcula(){
      var base = resp.piel === "sensible" ? 1 : 2;
      if(resp.exp === "irrito") base = 1;
      if(resp.exp === "bien") base = resp.piel === "sensible" ? 2 : 3;
      var despues = Math.min(base + 1, resp.piel === "sensible" ? 3 : 4);
      var media = (base * 2 + despues * 50) / 52;
      var tubos = (media * 52) / 60;
      var pack = tubos < 1.6 ? "1" : (tubos < 2.4 ? "2" : (tubos < 4 ? "3" : "5"));
      pauta = {ini:base, fin:despues, tubos:tubos, pack:pack};

      $("pSem12").textContent = base;
      $("pSem34").textContent = despues;
      $("pTubos").textContent = tubos.toFixed(1).replace(".", ",");
      $("pTexto").textContent = TEXTO[resp.meta] + " Con esa cuenta te cuadra el pack de " + PACKS[pack].label + ".";

      var cal = $("cal");
      cal.innerHTML = "";
      for(var d = 0; d < 28; d++){
        var semana = Math.floor(d / 7);
        var cuantas = semana < 2 ? base : despues;
        var hueco = Math.round(7 / cuantas);
        var toca = (d % 7) % hueco === 0 && Math.floor((d % 7) / hueco) < cuantas;
        var i = document.createElement("i");
        i.textContent = String(d + 1);
        i.style.animationDelay = (d * 18) + "ms";
        if(toca) i.className = "si";
        cal.appendChild(i);
      }
      $("espera").hidden = true;
      var caja = $("result"), primera = caja.hidden;
      caja.hidden = false;
      if(primera && !quieto) anima(caja, "nuevo");

    }
    todos(".ops button").forEach(function(b){
      b.addEventListener("click", function(){
        var grupo = b.parentNode;
        Array.prototype.forEach.call(grupo.children, function(o){ o.setAttribute("aria-pressed", String(o === b)); });
        resp[grupo.dataset.q] = b.dataset.v;
        if(resp.piel && resp.exp && resp.meta) calcula();
      });
    });
    // El boton es un enlace a la ficha del producto: se le pone el pack que cuadra
    var aPack = $("aPack");
    if(aPack) aPack.addEventListener("click", function(e){
      if(!pauta) return;
      e.preventDefault();
      var url = aPack.getAttribute("data-url") || aPack.getAttribute("href");
      window.location.href = url + (url.indexOf("?") > -1 ? "&" : "?") + "pack=" + pauta.pack;
    });
    $("copiar").addEventListener("click", function(){
      if(!pauta) return;
      var txt = "Mi pauta con Dermasens Retinal Night Shot 0,1 %\n"
        + "· Semanas 1-2: " + pauta.ini + " noches por semana\n"
        + "· Desde la semana 3: " + pauta.fin + " noches por semana\n"
        + "· Siempre en cara seca, hidratante encima y protección solar por el día\n"
        + "· Gasto estimado: " + pauta.tubos.toFixed(1).replace(".", ",") + " tubos al año";
      var ok = function(){ $("copiado").hidden = false; setTimeout(function(){ $("copiado").hidden = true; }, 2600); };
      function aPelo(t){
        var ta = document.createElement("textarea");
        ta.value = t; document.body.appendChild(ta); ta.select();
        try { document.execCommand("copy"); ok(); } catch(e){}
        document.body.removeChild(ta);
      }
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(txt).then(ok, function(){ aPelo(txt); });
      } else { aPelo(txt); }
    });
  })();

  /* ---------- menú del móvil ---------- */
  (function(){
    var btn = $("menuBtn"), raiz = document.documentElement;
    if (!btn) return;
    function cierra(){ raiz.classList.remove("menu-on"); btn.setAttribute("aria-expanded", "false"); }
    btn.addEventListener("click", function(){
      var abierto = raiz.classList.toggle("menu-on");
      btn.setAttribute("aria-expanded", String(abierto));
    });
    todos("#nav a").forEach(function(a){ a.addEventListener("click", cierra); });
    document.addEventListener("keydown", function(e){ if (e.key === "Escape") cierra(); });
    // al girar el movil o pasar a escritorio, el panel no se queda abierto a medias
    window.addEventListener("resize", function(){ if (window.innerWidth > 900) cierra(); });
  })();
  /* ---------- comparadores antes / despues ---------- */
  todos(".ba").forEach(function(ba){
    var r = ba.querySelector(".ba__range");
    var pon = function(){ ba.style.setProperty("--pos", r.value + "%"); };
    pon();
    r.addEventListener("input", pon);
    r.addEventListener("pointerdown", function(){ ba.classList.remove("guia"); });
    mirar(ba, function(){ if(!quieto) ba.classList.add("guia"); });   // el tirador se mueve solo hasta que lo tocas
  });

  /* ---------- barras de resenas y de porcentaje ---------- */
  mirar($("bars"), function(){
    todos("#bars b").forEach(function(b){ b.style.width = b.dataset.w; });
  });
  mirar(document.querySelector(".pcts"), function(el){ el.classList.add("ya"); });

  /* ---------- visor de video ---------- */
  (function(){
    var caja = $("lbox"), vid = $("lboxVid"), pie = $("lboxPie"), x = $("lboxX");
    if (!caja) return;
    var antes = null;
    function abrir(btn){
      antes = btn;
      vid.src = btn.getAttribute("data-clip");
      pie.textContent = btn.getAttribute("data-pie");
      caja.hidden = false;
      void caja.offsetWidth;
      caja.classList.add("on");
      x.focus();
      var p = vid.play();
      if (p && p.catch) p.catch(function(){});
    }
    function cerrar(){
      vid.pause();
      caja.classList.remove("on");
      caja.hidden = true;
      vid.removeAttribute("src"); vid.load();
      if (antes) { antes.focus(); antes = null; }
    }
    todos(".muro__i--v").forEach(function(btn){ btn.addEventListener("click", function(){ abrir(btn); }); });
    x.addEventListener("click", cerrar);
    caja.addEventListener("click", function(e){ if (e.target === caja) cerrar(); });
    document.addEventListener("keydown", function(e){ if (e.key === "Escape" && !caja.hidden) cerrar(); });
  })();

  /* ---------- ficha de producto: variantes reales, galeria y añadir ---------- */
  var D = window.DERMASENS || {};
  var R = D.rutas || {};
  var form = $("formProducto");
  var añadiendo = false;

  function fmt(cents){
    try {
      return new Intl.NumberFormat(D.idioma || "es", {style:"currency", currency: D.moneda || "EUR"}).format(cents / 100);
    } catch(e){ return (cents / 100).toFixed(2).replace(".", ",") + " €"; }
  }
  function pon(id, txt){ var e = $(id); if(e) e.textContent = txt; }
  function muestra(id, si){ var e = $(id); if(e) e.hidden = !si; }

  if(form){
    var selector = $("selectorVar");
    var radios = selector ? todos("#selectorVar option") : todos('#formProducto input[name="id"]').filter(function(r){ return r.type === "radio"; });
    var fijaMedia = ($("gal") || {}).dataset ? $("gal").dataset.fijaMedia === "1" : false;
    var umbral = (window.DERMASENS_PRODUCTO || {}).umbral || 20;
    var tiras = todos("#gal .gal__t"), vistas = todos("#gal .gal__v");

    function muestraMedia(id){
      if(!id || id === "0") return;
      var hay = vistas.some(function(v){ return v.getAttribute("data-v") === id; });
      if(!hay) return;
      tiras.forEach(function(t){
        var on = t.getAttribute("data-t") === id;
        t.classList.toggle("gal__t--on", on); t.setAttribute("aria-selected", String(on));
      });
      vistas.forEach(function(v){ v.classList.toggle("gal__v--on", v.getAttribute("data-v") === id); });
    }
    tiras.forEach(function(t){ t.addEventListener("click", function(){ muestraMedia(t.getAttribute("data-t")); }); });

    function actual(){
      if(selector) return selector.options[selector.selectedIndex];
      for(var i = 0; i < radios.length; i++) if(radios[i].checked) return radios[i];
      return form.querySelector('input[name="id"]');
    }
    function pintaVariante(conEfecto, cambiaMedia){
      var r = actual();
      if(!r) return;
      var d = r.dataset, n = parseInt(d.n, 10) || 1;
      pon("pNow", d.precio);
      var hayAntes = !!d.antes;
      muestra("pWas", hayAntes); if(hayAntes) pon("pWas", d.antes);
      muestra("pOff", !!d.pct); if(d.pct) pon("pOff", "−" + d.pct + " %");
      var partes = [];
      if(d.unidad) partes.push(d.unidad + " por " + (d.nombreUnidad || "unidad"));
      if(D.iva) partes.push("IVA incluido");
      muestra("pUnit", partes.length > 0);
      pon("pUnit", partes.join(" · "));
      muestra("ahorro", !!d.ahorro); if(d.ahorro) pon("ahorro", "Te ahorras " + d.ahorro);
      pon("btnPrice", d.precio);
      var st = parseInt(d.stock, 10) || 0;
      muestra("stock", st > 0 && st <= umbral);
      if(st > 0){
        pon("stockTxt", "Quedan " + st);
        var barra = $("stockBar");
        if(barra) barra.style.setProperty("--w", Math.max(6, Math.min(100, st / umbral * 100)) + "%");
      }
      pon("stickySub", (d.titulo ? d.titulo + " · " : "") + d.precio);
      if(cambiaMedia && !fijaMedia) muestraMedia(d.media);
      if(conEfecto && !quieto){ anima($("pNow"), "cambia"); if($("ahorro") && !$("ahorro").hidden) anima($("ahorro"), "cambia"); }
    }
    if(selector) selector.addEventListener("change", function(){ pintaVariante(true, true); });
    else radios.forEach(function(r){ r.addEventListener("change", function(){ pintaVariante(true, true); }); });

    // ?pack=N elige la variante cuyo pack lleva N tubos (si no hay, la N-esima)
    (function(){
      var m = /[?&]pack=(\d+)/.exec(window.location.search);
      if(!m || !radios.length) return;
      var N = parseInt(m[1], 10), elegido = null;
      radios.forEach(function(r){ if(!elegido && parseInt(r.dataset.n, 10) === N && !r.disabled) elegido = r; });
      if(!elegido && radios[N - 1] && !radios[N - 1].disabled) elegido = radios[N - 1];
      if(elegido){ if(selector) elegido.selected = true; else elegido.checked = true; }
    })();
    pintaVariante(false, true);

    // selector de cantidad
    todos(".cantidad__b").forEach(function(b){
      b.addEventListener("click", function(){
        var n = $("cantidadN"); if(!n) return;
        n.value = Math.max(1, (parseInt(n.value, 10) || 1) + parseInt(b.getAttribute("data-cant"), 10));
      });
    });

    // barra fija de la ficha: añade lo mismo que el boton grande
    var sa = $("stickyAdd");
    if(sa) sa.addEventListener("click", function(){ if(form.requestSubmit) form.requestSubmit(); else $("addBtn").click(); });

    form.addEventListener("submit", function(e){
      if(!window.fetch || !R.anadir) return;          // sin fetch, el envio normal de Shopify
      e.preventDefault();
      if(añadiendo) return;                           // doble pulsacion
      añadiendo = true;
      var btn = $("addBtn"), err = $("addErr");
      btn.classList.add("cargando");
      err.hidden = true;
      fetch(R.anadir, {method:"POST", headers:{"Accept":"application/json"}, body:new FormData(form)})
        .then(function(res){ return res.json().then(function(j){ return {ok:res.ok, j:j}; }); })
        .then(function(o){
          if(!o.ok){ throw new Error(o.j.description || o.j.message || "No se ha podido añadir."); }
          return refrescaCesta().then(function(){ anima($("openCart"), "salta"); abre(); });
        })
        .catch(function(ex){
          err.textContent = ex.message || "No se ha podido añadir. Inténtalo de nuevo.";
          err.hidden = false;
        })
        .then(function(){ añadiendo = false; btn.classList.remove("cargando"); });
    });
  }

  /* ---------- cesta real (API AJAX de Shopify) ---------- */
  var cart = $("cart"), scrim = $("scrim");
  var cartErr = $("cartErr");
  function esc(t){ var d = document.createElement("div"); d.textContent = t == null ? "" : String(t); return d.innerHTML; }

  function pintaCesta(c){
    var n = c.item_count || 0;
    var cuenta = $("cartCount");
    if(cuenta){ cuenta.textContent = n; cuenta.hidden = n < 1; }
    $("cartEmpty").hidden = n > 0;
    $("cartTotal").textContent = fmt(c.total_price);
    var pagar = $("pagar"); if(pagar) pagar.style.display = n > 0 ? "" : "none";
    var cont = $("cartLines");
    cont.innerHTML = "";
    c.items.forEach(function(it, i){
      var fila = document.createElement("div");
      fila.className = "cart__line";
      var img = it.image ? '<img src="' + esc(it.image) + '" width="70" height="70" alt="' + esc(it.featured_image && it.featured_image.alt || it.product_title) + '">' : '<span></span>';
      var variante = (it.variant_title && it.variant_title !== "Default Title") ? '<span class="cart__var">' + esc(it.variant_title) + '</span>' : "";
      fila.innerHTML = img + '<div><a href="' + esc(it.url) + '"><b>' + esc(it.product_title) + '</b></a>' + variante +
        '<span class="cart__pr">' + fmt(it.final_line_price) + '</span>' +
        '<div class="cart__ctl">' +
        '<button type="button" data-l="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Quitar uno">−</button>' +
        '<output>' + it.quantity + '</output>' +
        '<button type="button" data-l="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Añadir uno">+</button>' +
        '<button type="button" class="cart__quita" data-l="' + (i + 1) + '" data-q="0">Quitar</button>' +
        '</div></div>';
      cont.appendChild(fila);
    });
  }
  function refrescaCesta(){
    return fetch(R.carritoJs || "/cart.js", {headers:{"Accept":"application/json"}})
      .then(function(r){ return r.json(); })
      .then(function(c){ pintaCesta(c); return c; });
  }
  function cambia(linea, cantidad){
    cartErr.hidden = true;
    return fetch(R.cambiar || "/cart/change.js", {method:"POST", headers:{"Content-Type":"application/json","Accept":"application/json"},
      body: JSON.stringify({line: linea, quantity: cantidad})})
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
      .then(function(o){
        if(!o.ok){ cartErr.textContent = o.j.description || o.j.message || "No se ha podido cambiar la cantidad."; cartErr.hidden = false; return null; }
        pintaCesta(o.j);
      })
      .catch(function(){ cartErr.textContent = "No se ha podido cambiar la cantidad."; cartErr.hidden = false; });
  }
  $("cartLines").addEventListener("click", function(e){
    var b = e.target.closest("button[data-l]");
    if(!b || b.disabled) return;
    b.disabled = true;
    cambia(+b.getAttribute("data-l"), +b.getAttribute("data-q")).then(function(){ b.disabled = false; });
  });

  function abre(){
    cart.hidden = false;
    void cart.offsetWidth;
    cart.classList.add("on");
    scrim.classList.add("on");
    var st = $("sticky"); if(st) st.classList.remove("on");
    $("closeCart").focus();
  }
  function cierraCesta(){
    cart.classList.remove("on"); scrim.classList.remove("on");
    setTimeout(function(){ cart.hidden = true; }, 300);
  }
  $("openCart").addEventListener("click", function(e){
    if(!window.fetch) return;                          // sin JS el icono lleva a /cart
    e.preventDefault();
    refrescaCesta().then(abre, abre);
  });
  $("closeCart").addEventListener("click", cierraCesta);
  scrim.addEventListener("click", cierraCesta);
  document.addEventListener("keydown", function(e){ if(e.key === "Escape" && !cart.hidden) cierraCesta(); });
  // contador real al cargar (por si la pagina viene de la cache del navegador)
  if(window.fetch) refrescaCesta().catch(function(){});

})();
